import React from 'react';

//Components
import ReactPhoneInput from 'react-phone-input-2';

//Styles
import Styles from './PhoneInput.module.scss';

//Utils
import PropTypes from 'prop-types';

const PhoneInput = React.forwardRef(({value, validationError = null, placeholder, onChange}, ref) => (
    <div ref={ref} className={Styles.container}>
        <label className={[Styles.placeholder, validationError ? Styles.error : undefined].join(' ')}>
            {validationError || placeholder}
        </label>

        <div className={validationError ? Styles.errorContainer : null}>
            <ReactPhoneInput
                country={'nl'}
                preferredCountries={['nl', 'gb', 'de']}
                value={value}
                onChange={onChange}
                placeholder={''}
            />
        </div>
    </div>
));

PhoneInput.propTypes = {
    value: PropTypes.string.isRequired,
    validationError: PropTypes.string,
    placeholder: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};

export default PhoneInput